import clsx from 'clsx';
import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { levelListAPI } from '../../../api/learningNote';

import { TYPE, URL } from '../../../constant';
import { useLearningData, useUserInfo } from '../../../hooks';
import useAmplitude from '../../../hooks/useAmplitude';
import { appsflyer, appsflyerEventName } from '../../../utils/appsflyer';
import LearningTab from '../../learning/courseLearning/learningNote/GM/LearningTab';
import LearningNoteAnalysis from '../../learning/courseLearning/learningNote/LearningNoteAnalysis';
import LearningNoteCourse from '../../learning/courseLearning/learningNote/LearningNoteCourse';
import LearningNoteLevel from '../../learning/courseLearning/learningNote/LearningNoteLevel';
import LearningNoteTestResult from '../../learning/courseLearning/learningNote/LearningNoteTestResult';
import PayPopup2 from '../payment/PayPopup2';

function Note({ id, tab, isShowPayPopup, onClosePayPopup }) {
  const history = useHistory();
  const location = useLocation();
  const { info } = useUserInfo();
  const { setLearningData } = useLearningData();
  const { setAmplitudeLog } = useAmplitude();

  const [level, setLevel] = useState("");
  const [levelList, setLevelList] = useState([]);

  useEffect(() => {
    if (!level) levelListAPICall();
    let eventName = '';
    let appsflyerName = '';
    switch (tab) {
      case 'course_tab1': 
        eventName = '학습노트_코스학습 조회'; 
        appsflyerName = appsflyerEventName.progressreport_course;
        break;
      case 'theme': 
        eventName = '학습노트_주제학습 조회'; 
        appsflyerName = appsflyerEventName.progressreport_topic;
        break;
      case 'ocr': 
        eventName = '학습노트_ocr학습 조회'; 
        break;
    }
    setAmplitudeLog({ 
      eventCategory: 'app_usage', 
      eventName ,
      isHackleSend: eventName === '학습노트_코스학습 조회',
    });

    appsflyer({
      eventName: appsflyerName,
      evenntParams: null
    });
    
  }, [tab]);

  const onChangeLevel = (num) => {
    setLevel(num);
  };

  const levelListAPICall = useCallback(async () => {
    const { learnerId, channelCode } = info;
    const resp = await levelListAPI({
      channelCode, learnerId
    })
    if (resp?.code === 'S000000') {
      const { resp: data } = resp;
      
      const { pathname } = location;
      const params = pathname.replace('/courseLearning/learningNote', '');

      if (data && data.length > 0) {
        setLevelList(data);
        setLevel(params ? params.replace('/', '') : data[data.length - 1].lvlCd);
      }
    }
  }, []);

  const moveResult = (e, item) => {
    setLearningData({ stgCd: item.stgCd, prevPage: "learningNote" });
    history.push({
      pathname: `${URL.LEARNING.RESULT}`,
      state: {
        stgCd: item.stgCd,
        lrnEntyScnCd: TYPE.LEARNING.COURSE,
      }

    });
  };

  return (
    <div className="container study_note">
      {
        (tab === 'theme' || tab === 'ocr') && (
          <div className="inner">
            <div className="tabCont study_note_tab1 active" id="tabCont1">
              <div className="lev_boxes-wrap w800">
                <LearningTab tab={tab}/>
              </div>
            </div>
          </div>
        ) 
      }
      {
        (tab === 'course_tab1' || tab === 'course_tab2') && (
          <>
          <div 
            className={clsx(
              "tabCont active",
              tab === 'course_tab1' && 'study_note_tab1 '
            )}
            id={tab === 'course_tab1' ? 'tabCont1' : 'tabCont2'}
          >
            <div className="lev_boxes-wrap w800">
              <LearningNoteLevel
                onChangeLevel={onChangeLevel}
                levelList={levelList}
                id={id}
              />
              {
                tab === 'course_tab1' && (
                  <LearningNoteCourse
                    onChangeFlag={() => { }}
                    level={level}
                    learner={info.learnerId}
                    moveResult={moveResult}
                  />
                )
              }
              {
                tab === 'course_tab2' && (
                  <LearningNoteAnalysis
                    onChangeFlag={() => { }}
                    level={level}
                    learner={info.learnerId}
                  />
                )
              }
            </div>
          </div>
          { info.isPaymentCountry && !info.subScriptionPurchsYn &&
            isShowPayPopup && <PayPopup2 onClose={onClosePayPopup}/>}
          </>
        )
      }
      {
        tab === 'course_tab3' && (
          <LearningNoteTestResult
            onChangeFlag={() => {}}
            level={level}
            learner={info.learnerId}
          />
        )
      }
    </div>
  );
}

export default Note;